<template lang="pug">
//- An address is a thing you copy, never a thing you retype. The value itself
//- is the button, so it reads as the plain value its neighbours are instead of
//- a disabled input, and the copy affordance only appears under the cursor.
button.intake-address(type="button" :title="$t('Copy address')" @click="copy")
    span.intake-address__value {{ address }}
    i.intake-address__icon(:class="[copied ? 'el-icon-check' : 'el-icon-document-copy', { 'is-copied': copied }]")
</template>

<i18n>
{
    "de": {
        "Copy address": "Adresse kopieren"
    }
}
</i18n>

<script>
export default {
    name: 'IntakeAddress',
    props: {
        address: { type: String, required: true },
    },
    data() {
        return {
            copied: false,
        };
    },
    methods: {
        // Confirm only what actually happened: the write is refused outright
        // when the document is not focused, and a tick over an empty clipboard
        // is worse than no tick at all.
        copy() {
            navigator.clipboard
                .writeText(this.address)
                .then(() => {
                    this.copied = true;
                    setTimeout(() => {
                        this.copied = false;
                    }, 2000);
                })
                .catch(() => {});
        },
    },
};
</script>

<style lang="sass" scoped>
.intake-address
    display: inline-flex
    align-items: baseline
    gap: 6px
    max-width: 100%
    padding: 0
    border: 0
    background: none
    color: inherit
    font: inherit
    text-align: left
    cursor: pointer

    &:hover .intake-address__icon
        opacity: 1

.intake-address__value
    word-break: break-all

.intake-address__icon
    flex: none
    opacity: 0
    color: #909399
    transition: opacity .15s

    &.is-copied
        opacity: 1
        color: #67C23A
</style>
